import { AxiosResponse } from 'axios';
import { apisiseci, apisso } from './api';
import { UserData, UserDataSecondary } from '../interfaces/user';
import { actionTypes } from '../store/reducer';
import {
  clearSessionStorage,
  getPathToRedirectLogin as buildLoginPath,
  redirectToLogin,
} from '../utils/sessionRedirect';

export const saveTokens = (tokenSISECI: string): void => {
  localStorage.setItem('gov_access_token', tokenSISECI);
};

export const clearStorage = (): void => {
  clearSessionStorage();
};

export const getPathToRedirectLogin = (): string => buildLoginPath();

export const loginRedirectPrivider = (pathname: string): void => {
  redirectToLogin(pathname);
};

export const logout = async () => {
  if ((window as any)._env_.REACT_APP_SSO_LOGIN_PROVIDER === 'primary') {
    clearStorage();
    // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
    (window as any).open(
      `${(window as any)._env_.REACT_APP_SSO}/sso/sair?client_id=${(window as any)._env_.REACT_APP_CLIENT_ID
      }&redirect_uri=${window.location.href}`,
      '_self'
    );
  } else {
    clearStorage();
    (window as any).open(
      // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
      `${(window as any)._env_.REACT_APP_SSO_SECUNDARY}/logout?client_id=${(window as any)._env_.REACT_APP_CLIENT_ID
      }&response_type=${(window as any)._env_.REACT_APP_RESPONSE_TYPE
      }&redirect_uri=${window.location.href}`,
      '_self'
    );
  }
};

export const getDataUserSso = (token: string): Promise<AxiosResponse> =>
  apisso.get('/cidadaos/pro', {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

export const checarSessaoAtiva = (
  accessToken: string,
): Promise<AxiosResponse<{ logado: boolean }>> =>
  apisso.post('/checar/', {
    access_token: accessToken,
  });

export const getDataUserSecondary = (
  token: string,
  access_token_secondary: string
): Promise<AxiosResponse> =>
  apisiseci.get('/profile/externo', {
    headers: {
      Authorization: `Bearer ${token}`,
      'Authorization-Externo': access_token_secondary,
    },
  });

export const validateUserSSO = (code: string): Promise<AxiosResponse> =>
  apisso.post(
    '/validar_cidadao/',
    {
      code,
    },
    {
      headers: {
        'Content-Type': 'application/json',
      },
    }
  );

export const loginSigp = (
  code: string,
  redirect_uri?: string
): Promise<AxiosResponse> => {
  if ((window as any)._env_.REACT_APP_SSO_LOGIN_PROVIDER === 'primary') {
    return apisso.post('/validar/', {
      code,
      client_id: (window as any)._env_.REACT_APP_CLIENT_ID,
      client_secret: (window as any)._env_.SSO_CLIENT_SECRET,
      redirect_uri: `${(window as any)._env_.REACT_APP_URL}/login/callback/`,
    });
  }
  return apisiseci.post(
    '/login/externo/',
    {
      code,
      redirect_uri:
        redirect_uri || (window as any)._env_.REACT_APP_REDIRECT_URI,
    },
    {
      headers: {
        // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
        Authorization: (window as any)._env_.REACT_APP_API_SISECI_KEY,
      },
    }
  );
};

const secondaryDataUserAdapter = (data: UserDataSecondary): UserData => {
  const dataF = {
    nome: data.name || '',
    data_nascimento: data.dataNascimento || '',
    nome_mae: data.nomeMae || '',
    cpf: data.preferred_username || data.username || data.cpf || '',
    contato: {
      email: data.email || '',
    },
  };
  return dataF as UserData;
};

export const getUserData = async (
  token: string,
  access_token_secondary?: string
) => {
  if ((window as any)._env_.REACT_APP_SSO_LOGIN_PROVIDER === 'primary') {
    const { data } = await getDataUserSso(token);
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    return data[0];
  }

  const { data } = await getDataUserSecondary(access_token_secondary, token);
  return secondaryDataUserAdapter(data);
};

export const persistUserData = (data: UserData): void => {
  localStorage.setItem('gov_user_data', JSON.stringify(data));
};

export const bootstrapUserSession = async (
  dispatch: (action: { type: string; user: UserData }) => void
): Promise<boolean> => {
  const token = localStorage.getItem('gov_access_token');
  if (!token) {
    return false;
  }

  try {
    const { data: checarData } = await checarSessaoAtiva(token);
    if (!checarData.logado) {
      clearStorage();
      return false;
    }

    const data = await getUserData(token);
    dispatch({
      type: actionTypes.SET_USER,
      user: data,
    });
    persistUserData(data);
    return true;
  } catch (err) {
    console.log(err);
    clearStorage();
    return false;
  }
};

export const sendCodeForSISECI = async (
  code: string,
  history: any,
  dispatch?: (action: { type: string; user: UserData }) => void
) => {
  const pathname = localStorage.getItem('pathname_redirect_gov');

  try {
    const { data } = await loginSigp(
      code,
      `${window.location.origin}${window.location.pathname}`
    );
    if (data.access_token) {
      saveTokens(data.access_token);
      if (dispatch) {
        await bootstrapUserSession(dispatch);
      }
      const spathname = pathname === '/' ? '/home' : pathname;
      history.push(spathname || '/home', {
        message: data.message ? data.message : '',
      });
    }
  } catch (err) {
    console.log(err);
  }
};

export const getImageProfile = async (token: string) => {
  return apisso.get('cidadaos/foto/', {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
};
